import {
  CountResponse,
  PaginationQueryParams,
} from '@interfaces/common.interface';
import {
  Holiday,
  HolidayWithWordpressHolidayData,
} from '@interfaces/holidays.interface';

import api from './';

export type WhishlistedHolidaysRequestParams = Partial<PaginationQueryParams>;

export const {
  useGetWhishlistedHolidaysQuery,
  useRemoveWhishlistedHolidayMutation,
  useCountWhishlistedHolidaysQuery,
} = api.injectEndpoints({
  endpoints: (build) => ({
    getWhishlistedHolidays: build.query<
      HolidayWithWordpressHolidayData[],
      void
    >({
      query: () => ({
        url: 'whishlists/holidays',
      }),
      providesTags: ['whishlists'],
    }),
    countWhishlistedHolidays: build.query<CountResponse, void>({
      query: () => ({
        url: 'whishlists/holidays/count',
      }),
      providesTags: ['whishlists'],
    }),
    removeWhishlistedHoliday: build.mutation<Holiday[], string>({
      query: (id) => ({
        url: `whishlists/holidays/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['whishlists'],
    }),
  }),
});
